export type PasswordStrength = 0 | 1 | 2 | 3 | 4;

/** Coarse strength score: 0 empty, 1 too short, 2 acceptable, 3 good, 4 strong. */
export function passwordStrength(password: string): PasswordStrength {
  if (!password) return 0;
  if (password.length < 10) return 1;
  let score = 1;
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) score += 1;
  if (/\d/.test(password)) score += 1;
  if (/[^A-Za-z0-9]/.test(password) || password.length >= 16) score += 1;
  return Math.min(4, score) as PasswordStrength;
}

/** Which of the contract's password rules are already satisfied. */
export function passwordRequirements(password: string) {
  return {
    length: password.length >= 10,
    letters: /[a-zA-Z]/.test(password),
    numbers: /[0-9]/.test(password),
  };
}
